export function renderImageElementLayoutTemplate({
  columnHeader
}: {
  columnHeader: string
}): string {
  return `<Avatar className="size-10 overflow-hidden border">
          {imageUrl ? (
            <Image
              src={imageUrl}
              alt={title ? \`${columnHeader} image for \${title}\` : '${columnHeader} image'}
              fill
              sizes="40px"
              className="rounded-sm object-cover"
              unoptimized
            />
          ) : (
            <AvatarFallback>
              {String(title || imageUrl).substring(0, 2).toUpperCase()}
            </AvatarFallback>
          )}
        </Avatar>`
}
